import * as actionTypes from "./actionTypes";

export const loadLocale = () => ({
    type: actionTypes.LOAD_LOCALE
});

export const loadLocaleSucceeded = locale => ({
    type: actionTypes.LOAD_LOCALE_SUCCEEDED,
    locale
});

export const getLocales = () => ({
    type: actionTypes.GET_LOCALES
});

export const getLocalesSucceeded = locales => ({
    type: actionTypes.GET_LOCALES_SUCCEEDED,
    locales
});

export const changeLocale = locale => ({
    type: actionTypes.CHANGE_LOCALE,
    locale
});

export const changeLanguageSucceeded = locale => ({
    type: actionTypes.CHANGE_LOCALE_SUCCEEDED,
    locale
});